import React from 'react';
import ReactDOM from 'react-dom';
import { Root } from './app';
import { FocusStyleManager } from '@blueprintjs/core';

import './styles/index.scss';

// Hides CSS outline unless tab character is used.
FocusStyleManager.onlyShowFocusOnTabs();

ReactDOM.render(<Root/>, document.getElementById('root'));
